var React = require('react');

function ExclamationMarkInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"82.5","cy":"82.5","r":"82.5","fill":"#f3f8fc","key":0}),React.createElement("g",{"fillRule":"nonzero","key":1},[React.createElement("path",{"d":"M82 52.75c16.154 0 29.25 13.096 29.25 29.25S98.154 111.25 82 111.25 52.75 98.154 52.75 82 65.846 52.75 82 52.75zm0 2.5c-14.774 0-26.75 11.976-26.75 26.75S67.226 108.75 82 108.75 108.75 96.774 108.75 82 96.774 55.25 82 55.25z","fill":"#000","key":0}),React.createElement("path",{"d":"M84 70h-4l.408 17.418h3.188L84 70zm-.097 20.324L83.9 95h-3.802l.003-4.676h3.803z","fill":"#a8b8c0","key":1})])]);
}

ExclamationMarkInline.defaultProps = {"width":"165","height":"165","fill":"none","fillRule":"evenodd"};

module.exports = ExclamationMarkInline;

ExclamationMarkInline.default = ExclamationMarkInline;
